import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { SeoHead } from '@/components/seo/SeoHead';
import Navbar from '@/components/layout/Navbar';
import Footer from '@/components/layout/Footer';
import {
  SpeakingHero,
  TopicsDetail,
  Formats,
  MediaAndCredentials,
  InviteSection,
} from '@/components/speaking/SpeakingSections';
import InviteForm from '@/components/speaking/InviteForm';
import { useScroll } from '@/hooks/useSmoothScroll';
import { speaker } from '@/data/speaker';
import '@/styles/speaking.css';

const SpeakingPage = () => {
  const { hash } = useLocation();
  const { lenis } = useScroll();

  // A rota é lazy e o Lenis controla o scroll: o salto para #convite precisa
  // acontecer depois que a seção existe no DOM.
  useEffect(() => {
    if (!hash) return;
    const target = document.querySelector<HTMLElement>(hash);
    if (!target) return;
    const timer = window.setTimeout(() => {
      if (lenis) lenis.scrollTo(target, { offset: -90 });
      else target.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }, 120);
    return () => window.clearTimeout(timer);
  }, [hash, lenis]);

  return (
    <>
      <SeoHead
        route="/palestras"
        lang="pt-BR"
        title="Palestras e workshops — Johnny Vaz"
        description={`${speaker.thesis} Temas, formatos e convite para palestras, workshops e treinamento de IA in-company com Johnny Vaz.`}
        image={`${speaker.site}/images/og/palestrante-og.png`}
      />
      <Navbar />
      <main id="speaking-content" className="pulse-page" tabIndex={-1}>
        <SpeakingHero />
        <TopicsDetail />
        <Formats />
        <MediaAndCredentials />
        <InviteSection><InviteForm /></InviteSection>
      </main>
      <Footer />
    </>
  );
};

export default SpeakingPage;
